// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"6517b6c0","731":"5dcfb9ee","922":"2b6ed851"}[chunkId] + ".chunk.js";
};